import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'br', pure: false})
export class BrPipe implements PipeTransform {
    transform(value: string, args: any[] = null): any {
        return value.replace('\n', '<br>');
    }
}
